import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatError, money } from "../../lib/api";
import { DeskCollect } from "./DeskCollect";
import { DeskLedger } from "./DeskLedger";
import { DeskPayout } from "./DeskPayout";

const GREEN = ["paid", "processed"];
const AMBER = ["created", "requested", "queued", "pending", "processing", "scheduled"];
export const StatusPill = ({ status, testId }) => (
  <span data-testid={testId} className={`pill ${GREEN.includes(status) ? "published" : AMBER.includes(status) ? "draft" : "failed"}`}>{status}</span>
);
export const rupeesToMinor = (v) => Math.round(Number(v) * 100);

const Summary = ({ s }) => (
  <div className="desk-summary" data-testid="desk-summary">
    {[["collected-today", "Collected today", money(s.collected_today)], ["collected-month", "Collected this month", money(s.collected_month)],
      ["paid-today", "Paid out today", money(s.paid_out_today)], ["paid-month", "Paid out this month", money(s.paid_out_month)],
      ["awaiting", "Payouts in progress", `${money(s.awaiting_approval)} · ${s.awaiting_approval_count}`]].map(([k, label, v]) => (
      <div key={k} data-testid={`desk-summary-${k}`}><span>{label}</span><strong>{v}</strong></div>))}
  </div>
);

const TABS = [["collect", "Collect"], ["payout", "Pay out"], ["ledger", "Ledger"]];

export const PaymentsDesk = () => {
  const [tab, setTab] = useState("collect");
  const [summary, setSummary] = useState(null);
  const [config, setConfig] = useState(null);
  const refresh = useCallback(() => api.get("/admin/desk/summary").then((r) => setSummary(r.data)).catch((e) => toast.error(formatError(e))), []);
  useEffect(() => { refresh(); api.get("/admin/desk/config").then((r) => setConfig(r.data)).catch(() => {}); }, [refresh]);
  return (
    <div data-testid="payments-desk">
      <div className="section-title"><h2>Payments Desk</h2></div>
      {summary && <Summary s={summary} />}
      <div className="desk-tabs" role="tablist">{TABS.map(([k, label]) => (
        <button key={k} role="tab" aria-selected={tab === k} className={tab === k ? "active" : ""} data-testid={`desk-tab-${k}`} onClick={() => setTab(k)}>{label}</button>))}</div>
      {config && tab === "collect" && <DeskCollect enabled={config.payins_enabled} onChange={refresh} />}
      {config && tab === "payout" && <DeskPayout enabled={config.payouts_enabled} onChange={refresh} />}
      {tab === "ledger" && <DeskLedger />}
    </div>
  );
};
